import { defineStore } from 'pinia'
import type { Component } from 'vue'

export const useBreadcrumbStore = defineStore('breadcrumb', {
  state: () => ({
    items: [] as {
      text: string | string[]
      to?: string | { name: string }
      icon?: Component
    }[]
  }),
  actions: {
    setItems(
      items: {
        text: string | string[]
        to?: string | { name: string }
        icon?: Component
      }[]
    ) {
      this.items = items
    }
  },
  getters: {
    getPathItems: (state) => state.items
  }
})
